import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const drSettlementQueryKeys = {
  all: ['drSettlement'],
  list: (params) => [...drSettlementQueryKeys.all, 'list', params],
  drHistory: (params) => [...drSettlementQueryKeys.all, 'drHistory', params],
  additionalInfo: (drResourceSysId, params) => [
    ...drSettlementQueryKeys.all,
    'additionalInfo',
    drResourceSysId,
    params,
  ],
};

// ==================== DR 정산 목록 조회 ====================
/**
 * DR 정산 목록 조회
 * @param {Object} params - 쿼리 파라미터
 * @param {string} params.FromDate - 시작 날짜
 * @param {string} params.ToDate - 종료 날짜
 * @param {string} params.DrResourceName - DR 자원 이름
 * @param {string} params.StationName - 충전소 이름
 * @param {string} params.AppliedCblAlgorithm - 적용된 CBL 알고리즘
 * @param {string} params.AppliedCblAlgorithmVersion - 적용된 CBL 알고리즘 버전
 * @param {number} params.page - 페이지 번호
 * @param {number} params.pageSize - 페이지 크기
 * @param {string} params.OrderBy - 정렬 기준
 * @param {string} params.OrderDirection - 정렬 방향 (asc, desc)
 */
export const useDRSettlementList = (params = {}) => {
  return useQuery({
    queryKey: drSettlementQueryKeys.list(params),
    queryFn: async () => {
      const response = await api.get('/drivecore/stm/api/PowerContractNumberSettlement', { params });
      return response;
    },
    staleTime: 5 * 60 * 1000,
  });
};

/**
 * DR 이력 정산 조회
 * 
 * @param {Object} params - 쿼리 파라미터
 * @param {string} params.TargetDate - 대상 날짜(YYYY-MM-DD)
 * @param {string} params.StartEndTime - 시작 시간과 종료 시간 (HHMMHHMM)
 */
export const useDRSettlementForDrHistory = (params = {}) => {
  return useQuery({
    queryKey: drSettlementQueryKeys.drHistory(params),
    queryFn: async () => {
      const response = await api.get(`/drivecore/stm/api/PowerContractNumberSettlement/DrSettlement`, { params });
      return response;
    },
    enabled: !!params.TargetDate && !!params.StartEndTime,
  });
};

/**
 * 정산 및 결과의 부가정보 반환
 * 
 * @param {string} DrResourceSysId - DR 자원 시스템 ID
 * @param {Object} params - 쿼리 파라미터
 * @param {string} params.TargetRecordDate - 대상 날짜(YYYY-MM-DD)
 * @param {string} params.StartEndTime - 시작 시간과 종료 시간 (HHMMHHMM)
 */

export const useDRSettlementAdditionalInfo = (DrResourceSysId, params = {}) => {
  return useQuery({
    queryKey: drSettlementQueryKeys.additionalInfo(DrResourceSysId, params),
    queryFn: async () => {
      const response = await api.get(`/drivecore/stm/api/SettlementSupportRecord/${encodeURIComponent(DrResourceSysId)}`, { params });
      return response;
    },
    enabled: !!DrResourceSysId && !!params.TargetRecordDate && !!params.StartEndTime,
  });
};